import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MessageService } from '@app/shared/services/ui/message/message.service';
import { PageVertriebscockpitComponent } from '@app/views/vertriebscockpit/page/page.vertriebscockpit.component';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDeactivateGuard implements CanDeactivate<PageVertriebscockpitComponent> {
  messageService = inject(MessageService);


  canDeactivate(target: PageVertriebscockpitComponent): true | Observable<boolean> {
    if (target.hasUnsavedChanges) {
      return this.messageService.showSimpleYesNoDialog('Möchten Sie die Änderungen verwerfen?', 'Änderungen verwerfen')
        .afterClosed()
        .pipe(
          take(1),
          map(_dialogResult => _dialogResult?.status === 'yes')
        );
    }
    return true;
  }
}
